import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { StarRating } from '@flightstats/component-lib';

const OtherStopsTable = (props) => {
  const {
    stops,
    carrierCode,
    flightNumber,
  } = props;

  const titleCol = (title, mobileClass) => (
    <div className={`stops-col ${mobileClass}`}>
      <p className='title'>{title}</p>
    </div>
  );

  const tableHeader = (
    <div className='stops-header stops-row stops-underline'>
      {titleCol('Origin', 'origin-title')}
      {titleCol('Destination', 'destination-title')}
      {titleCol('Rating', 'rating-title')}
    </div>
  );

  const airportCol = (airport, destination) => {
    const {
      fs,
      name,
      city,
      state,
      country,
    } = airport;

    return (
      <div className='stops-col'>
        <p className={`title ${destination ? 'destination-airport' : ''}`}>{`(${fs}) ${name}`}</p>
        <p className={`subTitle ${destination ? 'destination-airport' : ''}`}>{`${city}${state ? `, ${state}` : ''}${country ? `, ${country}` : ''}`}</p>
      </div>
    );
  };

  const tableRows = stops.map((stop, index) => {
    const {
      departureAirport,
      arrivalAirport,
      rating,
      appraisal,
      roundedStars,
    } = stop;
    const url = `/flight-ontime-performance-rating/${carrierCode}/${flightNumber}/${departureAirport.fs}/${arrivalAirport.fs}`;
    const underlineClass = index !== (stops.length - 1) ? 'stops-underline' : '';
    return (
      <Link to={url} key={url}>
        <div className={`stops-row content-row ${underlineClass}`}>
          {airportCol(departureAirport)}
          {airportCol(arrivalAirport, true)}
          <div className='stops-col star-col'>
            <div style={{ minWidth: '120px' }}>
              <StarRating
                height={35}
                rating={roundedStars}
              />
            </div>
            <span className='star-appraisal'>
              {`${rating}  ${appraisal}`}
            </span>
          </div>
        </div>
      </Link>
    );
  });

  return (
    <div className='other-stops-table'>
      {tableHeader}
      {tableRows}
    </div>
  );
};

OtherStopsTable.propTypes = {
  stops: PropTypes.array,
  carrierCode: PropTypes.string,
  flightNumber: PropTypes.string,
};

export default OtherStopsTable;



// WEBPACK FOOTER //
// ./modules/OnTimePerformance/components/children/SingleFlight/children/OtherStopsTable.js